import { api } from "./api";

export const createDroperApi = (params) => {
    return api.post(`/admin/droper/create`, JSON.stringify(params));
};

export const editDroperApi = (params) => {
    return api.post(`/admin/droper/edit`, JSON.stringify(params));
};

export const listDroperApi = (params) => {
    return api.get(`/admin/droper/list`, { params });
};

export const viewDroperApi = (params) => {
    return api.get(`/admin/droper/view`, { params });
};

export const enableDisableDroperApi = (params) => {
    return api.post(`/admin/droper/enable-disable`, JSON.stringify(params));
};

export const resetPasswordDroperApi = (params) => {
    return api.post(`/admin/droper/reset-password`, JSON.stringify(params));
};


export const uploadDroperImageApi = (params) => {
    return api.post(`/admin/droper/upload-image`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};